<template>
  <v-app id="contents">
    <snackbar></snackbar>
    <router-view />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar.vue";

export default {
  name: "App",
  components: {
    Snackbar
  }
};
</script>

<style lang="scss">
$colorA: #08415c;
$colorB: #cc2936;
$colorC: #6b818c;
$colorD: #fcf7f8;
$colorE: #eee5e9;

$gradientA: #002435;
$gradientB: #0c638d;

html {
  overflow-y: hidden !important;
  background: $colorA;
}

#contents {
  background: radial-gradient(circle, $gradientB 0%, $gradientA 100%) fixed;
  height: 100vh;
  overflow: hidden;
}

.color-a {
  color: $colorA !important;
}
.color-e {
  color: $colorE !important;
}
.background--color-c {
  background: $colorC !important;
}
.background--color-d {
  background: $colorD !important;
}
.background--color-e {
  background: $colorE !important;
}
.background--transparent {
  opacity: 0.6;
}

/* SCROLLBAR */
::-webkit-scrollbar {
  width: 9px;
}
::-webkit-scrollbar-track {
  //background: $colorE;
  background: #002435;
  //border-radius: 9px;
}
::-webkit-scrollbar-thumb {
  background: $colorC;
  border: 3px solid transparent;
  border-radius: 9px;
  background-clip: content-box;
}
::-webkit-scrollbar-thumb:hover {
  background: $colorA;
  border: 2px solid transparent;
  border-radius: 9px;
  background-clip: content-box;
}
</style>
